<template>
  <div>
    <vDialog :show.sync="visible" class="withdraw_archive_card_dialog">
      <template v-slot:header>
        <span class="close"><i class="el-icon el-icon-close" @click="handleClose"></i></span>
        <div class="font-semibold text-xl text-blackG2">{{ $t('common.withdrawChannel.archive') }}</div>
      </template>
      <template #body>
        <div class="doc_upload">
          <div class="required-document">{{ $t('common.withdrawChannel.requiredDocument') }}</div>
          <div class="upload-tip">
            <span>{{ $t('fileUploader.supportedFormatCustom', { files: 'JPEG/JPG, PNG, PDF' }) }}, </span>
            <span>{{ $t('fileUploader.maxSize', { maxSize: '5' }) }}, </span>
            <span>{{ $t('fileUploader.maxFileNum', { maxFileNum: '1' }) }}</span>
          </div>
          <el-form :model="archiveForm" :rules="archiveFormRules" ref="archiveForm">
            <ul class="archiveForm">
              <li>
                <el-form-item class="upload" prop="cardBankLetterPath">
                  <div class="labelTitle">
                    <span class="required_icon">*</span>
                    <label for="">{{ $t('common.withdrawChannel.officialLetter') }}</label>
                  </div>
                  <vUpload
                    :limit="uploadLimit"
                    :selfText="true"
                    :selfTip="true"
                    :allowedFile="['png', 'jpg', 'jpeg', 'pdf']"
                    v-on:updateFileInfo="fileList => updateFileInfo(fileList, 'cardBankLetterPath')"
                  >
                    <div class="upload-btn">
                      <el-button class="blue_button" type="primary" data-testid="uploadBankLetter">
                        {{ $t('common.field.upload') }}
                      </el-button>
                    </div>
                  </vUpload>
                </el-form-item>
              </li>
              <li>
                <el-form-item class="upload" prop="cardStatementPath">
                  <div class="labelTitle">
                    <span class="red">* </span>
                    <label for="">{{ $t('common.withdrawChannel.bankStatement') }}</label>
                  </div>
                  <vUpload
                    :limit="uploadLimit"
                    :selfText="true"
                    :selfTip="true"
                    :allowedFile="['png', 'jpg', 'jpeg', 'pdf']"
                    v-on:updateFileInfo="fileList => updateFileInfo(fileList, 'cardStatementPath')"
                  >
                    <div class="upload-btn">
                      <el-button class="blue_button" type="primary" data-testid="uploadBankStatement">
                        {{ $t('common.field.upload') }}
                      </el-button>
                    </div>
                  </vUpload>
                </el-form-item>
              </li>
            </ul>
          </el-form>
        </div>
      </template>
      <template #btn>
        <el-row class="footer_btn">
          <el-button class="white_button" @click="handleClose">{{ $t('common.button.cancel') }}</el-button>
          <el-button class="blue_button" @click="onArchiveSubmit"
            >{{ $t('common.button.submit') }}
          </el-button>
        </el-row>
      </template>
    </vDialog>
    <vDialog :show.sync="dialog.show" :text="dialog.text">
      <template v-slot:btn>
        <div class="form_button">
          <el-button class="white_button" @click="dialog.show = false" data-testid="dialogCancel">
            {{ $t('common.button.cancel') }}
          </el-button>
          <el-button class="blue_button" v-if="archiveStatus" @click="archiveSubmit" data-testid="dialogSubmit">
            {{ $t('common.button.confirm') }}
          </el-button>
        </div></template
      >
    </vDialog>
  </div>
</template>

<script>
import { cardAuditSubmit, apiUpdateCreditCard } from '@/resource';
import vDialog from '@/components/vDialog.vue';
import PrimaryButton from '@/components/buttons/primaryButton/PrimaryButton.vue';
import SecondaryButton from '@/components/buttons/secondaryButton/SecondaryButton.vue';
import vUpload from '@/components/vUpload';

export default {
  name: 'withdrawArchiveCardDialog',
  components: { vDialog, PrimaryButton, SecondaryButton, vUpload },
  props: {
    ccDetail: Object,
    visible: Boolean
  },
  data() {
    const checkUploadFile = (rule, value, callback, name) => {
      if (!this.archiveForm[name]) {
        callback(new Error(this.$t('common.formValidation.file')));
      }
      callback();
    };
    const getUploadRules = name => {
      return [
        {
          validator: function (rule, value, callback) {
            checkUploadFile(rule, value, callback, name);
          },
          required: true,
          trigger: 'change'
        }
      ];
    };

    return {
      uploadLimit: 1,
      archiveStatus: false,
      TransferForm: {
        card_holder_name: '',
        expiry_month: '',
        expiry_year: '',
        importantNotes: ''
      },
      otherCcDetail: {
        cardBeginSixDigits: '',
        cardLastFourDigits: ''
      },
      archiveForm: {
        cardBankLetterPath: '',
        cardStatementPath: ''
      },
      archiveFormRules: {
        cardBankLetterPath: getUploadRules('cardBankLetterPath'),
        cardStatementPath: getUploadRules('cardStatementPath')
      },
      initialCcDate: {
        expiry_month: '',
        expiry_year: ''
      },
      dialog: {
        show: false,
        text: '',
        method: ''
      }
    };
  },
  methods: {
    resetUploadField() {
      this.archiveForm = {
        cardBankLetterPath: '',
        cardStatementPath: ''
      };
    },
    archiveSubmit() {
      const data = {
        ...this.otherCcDetail,
        ...this.archiveForm,
        expiryMonth: this.TransferForm.expiry_month,
        expiryYear: this.TransferForm.expiry_year
      };
      cardAuditSubmit(data)
        .then(resp => {          
          if (resp.data.code === 0) {
            this.responseMsg('success', this.$t('common.field.submitted'));
            this.resetUploadField();
            this.$root.$refs.topLeft.resetWithdrawalData();
          }
        })
        .catch(err => {
          this.responseMsg('error', this.$t('responseMsg.500'));
        });
    },
    responseMsg(type, msg) {
      this.$message({
        message: msg,
        type: type
      });
    },
    onExpiredCardUpdate() {
      const updatedCcData = { ...this.getUpdatedCreditCardData() };
      delete updatedCcData.card_holder_name;
      apiUpdateCreditCard(updatedCcData)
        .then(resp => {
          console.log('resp.data', resp.data);
          if (resp.data.code === 0 && resp.data) {
            this.responseMsg('success', this.$t('common.field.submitted'));
            this.$root.$refs.topLeft.resetWithdrawalData();
          }
        })
        .catch(err => {
          console.log('err', err);
          this.responseMsg('error', this.$t('responseMsg.500'));
        });
    },
    confirmPrompt(type) {
      const newExpiryMonth = parseInt(this.TransferForm.expiry_month);
      const newExpiryYear = parseInt(this.TransferForm.expiry_year);

      if (newExpiryMonth && newExpiryYear) {
        this.dialog.show = true;
        this.dialog.text = this.$t(`common.withdrawChannel.${type === 'archive' ? 'confirmArchive' : 'confirmUpdate'}`);
        this.archiveStatus = type === 'archive' ? true : false;
      }
    },
    onArchiveSubmit() {
      this.$refs['archiveForm'].validate(valid => {
        if (valid) {
          this.confirmPrompt('archive');
        } else {
          return Promise.resolve(false);
        }
      });
    },
    updateFileInfo(fileInfo, field) {
      this.archiveForm[field] = fileInfo.fileList[0];
      this.$refs['archiveForm'].validateField(field);
    },
    setDetail() {
      const creditCard = this.ccDetail.creditCard;

      this.initialCcDate.expiry_month = creditCard.expiry_month;
      this.initialCcDate.expiry_year = creditCard.expiry_year;

      this.TransferForm = {
        card_holder_name: creditCard.card_holder_name,
        expiry_month: creditCard.expiry_month,
        expiry_year: creditCard.expiry_year,
        importantNotes: ''
      };

      this.otherCcDetail = {
        cardBeginSixDigits: creditCard.card_begin_six_digits,
        cardLastFourDigits: creditCard.card_last_four_digits
      };
      this.withdrawable = this.ccDetail.balance;
    },
    handleClose() {
      this.$emit('update:visible', false);
    }
  },
  mounted() {
    this.setDetail();
  }
};
</script>
<style lang="scss" scoped>
.withdraw_archive_card_dialog {
  /deep/ .el-dialog {
    min-width: 600px;
    max-width: fit-content;
    .el-dialog__body .dialog_body a {
      color: #606266;
      display: block;
      margin-right: 40px;
      overflow: hidden;
      padding-left: 4px;
      text-overflow: ellipsis;
      transition: color 0.3s;
      white-space: nowrap;
      text-align: left;
      font-size: 14px;
      margin-top: 0;
      margin-bottom: 0;
    }
    .el-form-item__error {
      margin-top: 10px;
    }
  }

  .close {
    position: absolute;
    right: 20px;
    cursor: pointer;
  }

  .doc_upload {
    margin-top: 45px;
  }

  .required-document {
    font-size: 16px;
    line-height: 1;
    margin-bottom: 10px;
    text-align: left;
  }

  .upload-tip {
    margin-bottom: 30px;
    text-align: left;

    &.first {
      margin-bottom: 30px;
    }
  }

  .archiveForm {
    display: flex;
    flex-direction: column;
    // grid-template-columns: 48% 48%;
    // column-gap: 4%;
    gap: 20px;

    .labelTitle {
      margin-bottom: 10px;
      text-align: left;
      white-space: nowrap;

      label {
        color: #0051ff;
      }
    }

    .upload-btn {
      position: absolute;
      top: 0;
    }

    .el-form-item__error {
      margin-top: 10px;
    }

    @media (max-width: 768px) {
      display: block;
    }
  }

  .footer_btn {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }

  @media (max-width: 768px) {
    /deep/ .el-dialog {
      min-width: fit-content;
    }

    .archiveForm {
      .labelTitle {
        white-space: normal;
      }
    }
  }
}
</style>
